export default "__VITE_ASSET__DnB5YP51__"